export const PROGRESS_LABELS = {
  "Image Capture": [
    { label: "Taken Timely", countKey: "takentimely" },
    { label: "Taken Late", countKey: "takenlate" },
    { label: "Missing Sticker", countKey: "missingsticker" },
    { label: "Auto Traced", countKey: "autotraced" },
    { label: "Manually Traced", countKey: "manuallytraced" },
  ],
  Assessments: [
    { label: "Performed Timely", countKey: "performedtimely" },
    { label: "Performed Late", countKey: "performedlate" },
    { label: "Last Assessed Over 7 Days Ago", countKey: "lastassessedover7daysago" },
    { label: "Tissue Types Not Set", countKey: "tissuetypesnotset" },
    { label: "Touch & View Details Not Set", countKey: "touchviewdetailsnotset" },
    { label: "Classification Not Set", countKey: "classificationnotset" },
    { label: "Wound Progress Not Set", countKey: "woundprogressnotset" },
  ],
  Measurements: [
    { label: "No Surface Area", countKey: "nosurfacearea" },
    { label: "No Length", countKey: "nolength" },
    { label: "No Width", countKey: "nowidth" },
    { label: "No Depth", countKey: "nodepth" },
    { label: "No Undermining", countKey: "noundermining" },
    { label: "No Tunneling", countKey: "notunneling" },
  ],
  Treatments: [
    { label: "Dressing Appearance Not Set", countKey: "dressingappearancenotset" },
    { label: "Primary Dressing Not Set", countKey: "primarydressingnotset" },
    { label: "Secondary Dressing Not Set", countKey: "secondarydressingnotset" },
    { label: "Dressing Change Frequency Not Set", countKey: "dressingchangefrequencynotset" },
  ],
};
